import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import formatDate from "../../../utils/helpers";
import { getNotifications } from "../../redux/actions/notifications";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const statusStyles = {
  green: "bg-green-100 text-green-800",
  yellow: "bg-yellow-100 text-yellow-800",
  red: "bg-red-100 text-red-800",
};

export default function Notification() {
  const { notifications } = useSelector((state) => state.notifications);

  console.log(notifications);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  if (notifications.length === 0) {
    return <p>There are no notifications</p>;
  }

  return (
    <>
      {notifications.length !== 0 && (
        <div className="px-4 sm:px-6 lg:px-8 py-8">
          <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-xl font-semibold text-gray-900">
                Notifications
              </h1>
            </div>
          </div>
          <div className="-mx-4 mt-8 overflow-hidden ring-1 ring-black ring-opacity-5 sm:-mx-6 md:mx-0 md:rounded-sm">
            <div className="min-w-full divide-y divide-gray-300">
              <div className="divide-y divide-gray-200 bg-white">
                {notifications.map((notification) => (
                  <Link
                    to={`${notification.id}`}
                    key={notification.id}
                    className={classNames(
                      !notification.attributes.isRead
                        ? "bg-red-50 border border-red-400 hover:bg-red-100"
                        : "hover:bg-gray-100",
                      "grid grid-cols-3 hover:bg-slate-100 hover:cursor-pointer"
                    )}
                  >
                    <div className="hidden px-3 py-4 text-sm text-gray-500 md:flex">
                      From{" "}
                      <span
                        className={classNames(
                          statusStyles[notification.attributes.prevStatus],
                          "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
                        )}
                      >
                        {notification.attributes.prevStatus}
                      </span>{" "}
                      to{" "}
                      <span
                        className={classNames(
                          statusStyles[notification.attributes.newStatus],
                          "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
                        )}
                      >
                        {notification.attributes.newStatus}
                      </span>
                    </div>
                    <div className="px-3 py-4 text-sm text-gray-500 md:flex md:flex-col">
                      {notification.attributes.reason}
                      <div className="py-4 text-sm text-gray-500 md:hidden">
                        {formatDate(notification.attributes.createdAt)}
                      </div>
                    </div>
                    <div className="hidden md:flex px-3 py-4 text-sm justify-end text-gray-500">
                      {formatDate(notification.attributes.createdAt)}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
